"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BackgroundIllustrationTop = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "illustration-background-top" },
            react_1.default.createElement("svg", { className: "illustration-background-top__svg", width: "1366", height: "656", viewBox: "0 0 1366 656", fill: "none", preserveAspectRatio: "none" },
                react_1.default.createElement("path", { d: "M1366 651.438C1366 651.438 1177.87 516.949 1031.51 508.936C912.456 502.417 827.379 628.447 709.038 651.437C551.675 682.008 431.93 547.919 274.402 575.945C153.716 597.417 3.98854e-07 651.438 3.98854e-07 651.438L5.73493e-05 2.6508e-06L1366 0.00012207L1366 651.438Z", fill: "#EDF4F8" })))));
};
exports.default = BackgroundIllustrationTop;
